import { http_api } from "../../leadg-api";
const getTree = () => http_api.get("object-statuses/tree");
const create = (dto) => http_api.post("object-statuses", dto);
const update = (dto) => http_api.put("object-statuses", dto);
const remove = (id) => http_api.delete(`object-statuses/${id}`);
const getSelections = (objectId) => http_api.get(`object-statuses/objects/${objectId}/selections`);
const upsertSelections = (objectId, pathIds, leadId) => http_api.post(`object-statuses/objects/${objectId}/selections${leadId ? `?leadId=${leadId}` : ''}`, pathIds);
const getSelectionsBatch = (objectIds) => http_api.post(`object-statuses/objects/selections-batch`, objectIds);
const updateStatus = (id, isActive) => http_api.patch(`object-statuses/${id}/status`, { isActive });
const objectStatusApi = {
    getTree,
    create,
    update,
    remove,
    getSelections,
    getSelectionsBatch,
    upsertSelections,
    updateStatus
};
export default objectStatusApi;
